import React, {createContext,  useReducer} from "react";
import {IGlobalStateInit} from "@extension/globalContext/interface";
import useDispatch from "@extension/globalContext/useDispatch";
import reducer from "@extension/globalContext/reducer";
import {initialState} from "@extension/globalContext/initState";

interface Props {
    value: IGlobalStateInit,
    children: any
}
export const GlobalContext = createContext(initialState);

export const GlobalProvider = (props: Props) => {
    const {value, children} = props;
    const [state, dispatch] = useReducer(reducer, value);
    const dispatchers = useDispatch({dispatch})

    return <GlobalContext.Provider value={{
        ...state,
        ...dispatchers
    }}>
        {children}
    </GlobalContext.Provider>;
};
